import React from "react";
import "../../../../css/pages/ca_pages/models/dashboard/NeedsAttention.css";

const mockData = [
    {
        id: 1,
        type: "Overdue Document Request",
        client: "ABC Pvt Ltd",
        business: "Trading Division",
        priority: "high",
        due: "2 days overdue",
    },
    {
        id: 2,
        type: "Invoice Processing Pending",
        client: "XYZ Industries",
        business: "Manufacturing Unit",
        priority: "medium",
        due: "Waiting for review",
    },
    {
        id: 3,
        type: "Missing Documents",
        client: "John Enterprises",
        business: "Retail Store",
        priority: "low",
        due: "Requested 5 days ago",
    },
];

const NeedsAttention = () => {
    return (
        <div className="caDashPro__attentionCard">
            <div className="caDashPro__attentionHeader">
                <h3>Needs Attention</h3>
                <span className="caDashPro__badge">
                {mockData.length} items
                </span>
            </div>

            <div className="caDashPro__attentionList">
                {mockData.map((item) => (
                    <div key={item.id} className="caDashPro__attentionItem">
                        <div className="caDashPro__attentionLeft">
                            <p className="caDashPro__attentionType">
                                {item.type}
                            </p>

                            <p className="caDashPro__attentionMeta">
                                {item.client} • {item.business}
                            </p>

                            <p className="caDashPro__attentionDue">
                                {item.due}
                            </p>
                        </div>

                        <div className="caDashPro__attentionRight">
                            <span className={`caDashPro__priority ${item.priority}`}>
                                {item.priority}
                            </span>

                            <button className="caDashPro__viewBtn">
                                View
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default NeedsAttention;
